// extracted by mini-css-extract-plugin
export default {"root":"ip9iMqbA201uRleKWhCn","player":"yCeYJecSQQ9s9GJCHlZd","poster":"GcE35Vw3V8DtWnfZTCjJ"};